<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XZlWCm/tc-custom/9781497623514.jpg?1707592310187" alt="This image is the cover for the book Contours of Darkness, The Vassi Collection"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Contours of Darkness, The Vassi Collection
      </h1>
      <p class="bookDescription body article font2">
        <i>“They had their words and their deeds; and the relationship between the two functions of their being formed the pattern of the lives. They sought the eternal through the passage of time, and searched for love in the rubric of sex. They huddled beneath their private solutions to the vast problems of their age until they saw that history was a director that used them ruthlessly and without asking permission to include them in its its play.”</i> I must not succumb . . . she thought.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marco Vassi
      </h2>
      
      <p class="authorDescription body article">Marco Vassi was, without a doubt, the foremost erotic writer of our generation. Praised by Norman Mailer, Kate Millett, Saul Bellow, and Gore Vidal, he was not only the ultimate sexual explorer, but a literary craftsman whose own life experiences became the stuff of his fiction&mdash;expanded, of course, by a grand imagination and a full sense of the absurd.<BR /><BR /> Tragically, Vassi died from pneumonia after he had contracted AIDS.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?14ac0cd2